import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb />
      <main>
        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              关于我们
            </h1>
            <p className="text-sm text-foreground-500 mb-10">
              了解哔咔漫画官方指南的使命与团队
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 mb-14">
              <div className="lg:col-span-2">
                <div className="rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20illustration%20of%20a%20reading%20nook%20with%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20surrounded%20by%20manga%20volumes%20and%20warm%20ambient%20lighting%2C%20anime%20art%20style%2C%20soft%20coral%20and%20warm%20tones%2C%20inviting%20atmosphere&width=600&height=500&seq=about-brand-intro&orientation=portrait"
                    alt="哔咔漫画阅读场景"
                    className="w-full object-cover"
                    title="哔咔漫画官方指南品牌形象"
                  />
                </div>
              </div>
              <div className="lg:col-span-3">
                <h2 className="text-xl font-heading text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    哔咔漫画官方指南（bika-comic.com）成立于2023年，是哔咔漫画的非官方教程支持网站。我们致力于为二次元爱好者和哔咔漫画新用户提供最全面、最详细的哔咔下载、注册和使用教程。
                  </p>
                  <p>
                    哔咔漫画作为深受二次元爱好者喜爱的漫画阅读平台，汇聚了海量正版漫画资源。然而，许多新用户在初次使用时可能会遇到下载、注册或操作上的疑问。我们的使命就是通过详尽的图文教程，帮助每一位漫画爱好者顺利上手哔咔漫画。
                  </p>
                  <p>
                    我们的内容涵盖安卓和iOS双平台的下载安装教程、账号注册流程详解、各类特色功能的使用指南、常见问题的解决方案以及进阶使用技巧。每一篇文章都由经验丰富的哔咔用户精心编写，确保内容准确、实用、易懂。
                  </p>
                  <p>
                    我们坚信，漫画是连接人心的桥梁。通过哔咔漫画这个优秀的平台，二次元文化得以更广泛地传播。哔咔漫画官方指南愿成为你漫画之旅的贴心向导，让阅读漫画变得更加简单和愉快。
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-heading text-foreground-950 mb-6">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center space-x-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "本来不知道怎么安装哔咔漫画，看了这个网站的教程一步步操作，五分钟就搞定了。图文并茂，讲得非常清楚！"
                  </p>
                  <p className="text-xs text-foreground-400">—— 小明，大学生</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center space-x-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "之前一直用网页版看漫画，看了功能特色介绍才知道APP有离线下载和夜间模式，体验提升太多了！感谢详细的教程。"
                  </p>
                  <p className="text-xs text-foreground-400">—— 阿琳，设计师</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center space-x-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "常见问题板块帮了我大忙！白屏问题按照教程操作就解决了，不用到处找攻略。强烈推荐给所有哔咔新用户。"
                  </p>
                  <p className="text-xs text-foreground-400">—— 大强，程序员</p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-heading text-foreground-950 mb-6">
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100/70 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-500">support@bika-comic.com</p>
                      <p className="text-xs text-foreground-400 mt-0.5">工作日24小时内回复</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-accent-100/70 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-medium text-foreground-900 mb-1">微信公众号</h3>
                      <p className="text-sm text-foreground-500">哔咔漫画指南</p>
                      <p className="text-xs text-foreground-400 mt-0.5">关注获取最新教程推送</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-100/70 flex items-center justify-center flex-shrink-0">
                      <i className="ri-send-plane-line text-secondary-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-medium text-foreground-900 mb-1">官方微博</h3>
                      <p className="text-sm text-foreground-500">@哔咔漫画指南</p>
                      <p className="text-xs text-foreground-400 mt-0.5">实时更新平台动态</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 rounded-lg p-6">
                  <h3 className="text-base font-heading text-foreground-950 mb-4">友情链接</h3>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between py-2 border-b border-background-200/70">
                      <span className="text-sm text-foreground-600">哔咔漫画官方网站</span>
                      <a
                        href="#"
                        className="text-xs text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                        rel="nofollow"
                      >
                        访问官网 <i className="ri-external-link-line"></i>
                      </a>
                    </div>
                    <div className="flex items-center justify-between py-2 border-b border-background-200/70">
                      <span className="text-sm text-foreground-600">动画资源推荐</span>
                      <a
                        href="#"
                        className="text-xs text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                        rel="nofollow"
                      >
                        去看看 <i className="ri-external-link-line"></i>
                      </a>
                    </div>
                    <div className="flex items-center justify-between py-2">
                      <span className="text-sm text-foreground-600">二次元社区</span>
                      <a
                        href="#"
                        className="text-xs text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                        rel="nofollow"
                      >
                        加入社区 <i className="ri-external-link-line"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-8 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              <div className="bg-background-50 rounded-lg p-5">
                <h3 className="text-sm font-medium text-foreground-900 mb-2">
                  这个网站是哔咔漫画官方的吗？
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  本网站（bika-comic.com）是哔咔漫画的非官方教程指南网站，由哔咔漫画爱好者创建和维护。我们提供哔咔漫画的使用教程和常见问题解答，帮助新用户更好地使用哔咔漫画平台。如需官方服务，请直接访问哔咔漫画官方渠道。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5">
                <h3 className="text-sm font-medium text-foreground-900 mb-2">
                  网站上的教程是否免费？
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  是的，哔咔漫画指南网站上的所有教程内容完全免费。我们的初心是帮助更多二次元爱好者顺利使用哔咔漫画，所有文章都可以自由阅读，无需付费或注册。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '哔咔漫画官方指南',
            url: typeof window !== 'undefined' ? window.location.origin : '',
            description: '哔咔漫画非官方教程指南网站，为二次元爱好者提供哔咔下载、注册和使用教程。',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'support@bika-comic.com',
              contactType: 'customer support',
            },
          }),
        }}
      />
    </>
  );
}